const TAG_FIELD_CONFIG_BY_TYPE_CODE = {
  LANGUAGE: {
    valueKeys: ["selectedLanguages", "languages"],
    optionKeys: ["languageOptions"],
    addLabel: "Language",
  },
  KEYWORD_TAG: {
    valueKeys: ["keywords"],
    optionKeys: ["keywordOptions"],
    addLabel: "Keyword Tag",
  },
  HIDDEN_TAG: {
    valueKeys: ["hiddenTags"],
    optionKeys: ["hiddenTagOptions"],
    addLabel: "Hidden Tag",
  },
  LOCATION: {
    valueKeys: ["selectedLocations", "locations"],
    optionKeys: ["locationOptions"],
    addLabel: "Location",
  },
  OCCUPATION: {
    valueKeys: ["selectedOccupations", "occupations"],
    optionKeys: ["occupationOptions"],
    addLabel: "Occupation",
  },
};

const DEFAULT_TAG_COMPONENT = "CHECKBOX_LIST";

const toTagTypeCode = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();

const toTagComponentCode = (value) => {
  const normalized = String(value || "")
    .trim()
    .toUpperCase();
  return normalized || DEFAULT_TAG_COMPONENT;
};

const toTagTitleFromTypeCode = (typeCode) => {
  const normalizedTypeCode = toTagTypeCode(typeCode);
  if (!normalizedTypeCode) {
    return "Tag";
  }

  return normalizedTypeCode
    .toLowerCase()
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

const toTagOptionLabel = (value) => {
  if (typeof value === "string") {
    return value.trim();
  }

  if (!value || typeof value !== "object") {
    return "";
  }

  return String(value.Attribute || value.label || value.name || "").trim();
};

const flattenConfigAttributeGroups = (config) => {
  if (!config || typeof config !== "object") {
    return [];
  }

  const candidateGroups = [
    config.attributeTypes,
    config.attributes,
    config.contentAttributes,
    config.configContentSettings,
  ];

  return candidateGroups.filter(Array.isArray).flat();
};

const normalizeTagDefinition = (entry) => {
  const section = String(entry?.Section || "")
    .trim()
    .toUpperCase();
  if (section !== "SETTINGS") {
    return null;
  }

  const attributeTypeCode = toTagTypeCode(entry?.AttributeTypeCode);
  if (!attributeTypeCode) {
    return null;
  }

  const componentTypeCode = toTagComponentCode(entry?.ComponentTypeCode);

  const options = Array.isArray(entry?.Attributes)
    ? entry.Attributes.map(toTagOptionLabel).filter(Boolean)
    : [];

  return {
    attributeTypeCode,
    attributeType: String(
      entry?.AttributeType || toTagTitleFromTypeCode(attributeTypeCode),
    ).trim(),
    componentTypeCode,
    options,
  };
};

export const getTagFieldConfig = (typeCode) => {
  return TAG_FIELD_CONFIG_BY_TYPE_CODE[toTagTypeCode(typeCode)] || null;
};

export const getTagTitleFromTypeCode = (typeCode) => {
  return toTagTitleFromTypeCode(typeCode);
};

export const extractSettingsTagDefinitions = (config) => {
  const flattened = flattenConfigAttributeGroups(config);
  const seen = new Set();

  return flattened.map(normalizeTagDefinition).filter((entry) => {
    if (!entry) {
      return false;
    }

    if (seen.has(entry.attributeTypeCode)) {
      return false;
    }

    seen.add(entry.attributeTypeCode);
    return true;
  });
};

export const buildTagOptionsByTypeCode = (tagDefinitions = []) => {
  return tagDefinitions.reduce((acc, definition) => {
    acc[definition.attributeTypeCode] = Array.isArray(definition.options)
      ? definition.options
      : [];
    return acc;
  }, {});
};
